module.exports = __webpack_public_path__ + "static/service-1-c5e81e23f20e116ca2904a3e8a445604.jpg";